/**
 * Utility function that allows to expand gzip and zip files without really expanding them
 * @param fileCollection
 * @param options
 * @returns
 */
export async function maybeFilter(fileCollectionItems, options = {}) {
    const { ignoreDotfiles = true } = options;
    if (ignoreDotfiles) {
        fileCollectionItems = fileCollectionItems.filter((item) => item.relativePath.split('/').filter((part) => part.startsWith('.'))
            .length === 0);
    }
    return fileCollectionItems;
}
//# sourceMappingURL=maybeFilter.js.map